namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'dashboard-overview-component-template',
        bindings: {}
    })
    class DashboardOverviewComponent {
        public polls = null;

        public constructor(public RepositoryService: RepositoryService) {
            this.getPolls();
        }

        getPolls() {
            this.RepositoryService.getPollsOverview().then((polls) => {
                this.polls = polls;
            });
        }
    }
}